import { breakSettings, refreshSlider } from "@grindex-client/components/Slider/slider";

function init() {
	const initSlider = () => {
		$(".mobile ~ .home-page-wrapper .explore-our-solutions .cards").bxSlider({
			slideMargin: 10,
			pager: false,
			breaks: [
				{ screen: 0, slides: 1 },
				{ screen: 550, slides: 2 },
				{ screen: 768, slides: 3 },
			],
		});
	};

	const initBrandLogosCarousel = () => {
		const $brands = [...document.querySelectorAll(".component-cardCarouselBlock ul.cardSlider:has(.card-brand)")];

		for (const $brand of $brands) {
			$brand.classList.add("isBrandCarousel");

			const $items = [...$brand.querySelectorAll("li")];

			for (const $item of $items) {
				$item.classList.add("isBrand");
			}
		}

		$($brands).bxSlider({
			pager: false,
			controls: true,
			breaks: [
				{ screen: 0, slides: 1 },
				{ screen: 460, slides: 3 },
				{ screen: 1024, slides: 5 },
			],
			slideMargin: 20,
			pause: 5000,
		});
	};

	const initCardCarousel = () => {
		const $sliders = document.querySelectorAll(".home-page .cardSlider:not(.isBrandCarousel):not(.social)");

		$sliders.forEach(($slider) => {
			$($slider).bxSlider({
				slideWidth: 208,
				minSlides: 1,
				maxSlides: 4,
				breaks: breakSettings.smallCardBreakSettings,
				pager: false,
				slideMargin: 20,
				pause: 5000,
				autoReload: false,
				useCSS: false,
				onSliderRedraw() {
					refreshSlider($slider);
				},
			});
		});
	};

	const initSocialCardCarousel = () => {
		const $slider = document.querySelector(".home-page .component-socialFeed .cardSlider");
		if (!$slider) {
			return;
		}

		const upTime = $slider.getAttribute("data-pause");

		$($slider).bxSlider({
			auto: true,
			slideWidth: 208,
			minSlides: 1,
			maxSlides: 4,
			breaks: breakSettings.smallCardBreakSettings,
			pager: false,
			slideMargin: 20,
			pause: upTime ? upTime * 1000 : 10000,
			autoHover: true,
			autoReload: false,
			useCSS: false,
			onSliderRedraw() {
				refreshSlider($slider);
			},
		});
	};

	initSlider();
	initBrandLogosCarousel();
	initCardCarousel();
	initSocialCardCarousel();
}
export default {
	view: "startPage",
	init,
};
